<template>
    <div class="acc-photo-index">
        <Table :tableThData="tableThData" :tableTrData="tableTrData" :loading="loading" :limit="limit" :offset="offset"
            :total="total" v-on:handleSizeChange="handleSizeChange" v-on:handleCurrentChange="handleCurrentChange">
            <template #updated="{ row }">{{ row.updated ? $moment(row.updated).format('YYYY/MM/DD HH:mm:ss') : '---'
            }}</template>
            <template #pointsRule="{ row }">{{ row.pointsRule }}</template>
            <template #mallName="{ row }">{{ row.mallName }}</template>
            <template #operation="{ scope }">
                <auth-button auth="member:point:apply:examine">
                    <el-button type="text" @click="onApply(scope.row)">更新</el-button>
                </auth-button>
            </template>
        </Table>

        <!-- 弹窗 -->
        <Dialog :maskClose="false" :dialogShow="DialogShow" title="积分规则说明" @maskClick="() => { DialogShow = false }">
            <template>
                <div class="apply">
                    <el-form :hide-required-asterisk="true" ref="applyForm" :model="applyForm" label-width="100px">
                        <el-form-item :rules="[{ required: true, message: '请输入积分规则' },]" label="积分规则" prop="pointsRule">
                            <el-input placeholder="请输入积分规则" v-model="applyForm.pointsRule" type="textarea" maxlength="1000" :autosize="{ minRows: 20, maxRows: 20}" show-word-limit ></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="button-div">
                        <el-row class="button-div-row">
                            <el-button type="default" class="cancel" @click="() => { DialogShow = false }">取消</el-button>
                            <el-button type="primary" :loading="DialogLoading" class="determine"
                                @click="determine">确定</el-button>
                        </el-row>
                    </div>
                </div>
            </template>
        </Dialog>
    </div>
</template>
  
<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList';
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import Dialog from "@/components/Dialog/index";
import { api_getRuleInfoList, api_postUpdateRuleInfo } from '@/api/accumulationScore'
export default {
    name: "accFlowIndex",
    mixins: [tableList],
    components: {
        AuthButton,
        Search,
        Table,
        Dialog
    },
    data() {
        return {
            tableThData: [
                { prop: "updated", label: "更新时间", minWidth: "180", },
                { prop: "mallName", label: "商场名称", minWidth: "180", },
                { prop: "pointsRule", label: "积分规则", minWidth: "180", },
                { prop: "operation", label: "操作", minWidth: "150", },
            ],
            DialogShow: false,
            DialogLoading: false,
            applyForm: {
                pointsRule: '',
                id: '',
            },
        };
    },
    created() {
    },
    methods: {
        // 获取拍照积分规则
        async getList() {
            console.log('获取拍照积分规则')
            this.loading = true
            try {
                const params = {
                    offset: this.offset,
                    limit: this.limit,
                }
                const data = await api_getRuleInfoList(params)
                console.log(data)
                // let list = [{
                //     pointsRule: data.pointsRule,
                //     updated: data.updated,
                //     id: data.id
                // }]
                this.tableTrData = data.list
                this.total = data.count
                this.loading = false
            } catch {
                this.loading = false
            }
        },
        // 点击更新按钮
        onApply(row) {
            console.log(row)
            this.DialogShow = true
            this.applyForm = {
                pointsRule: row.pointsRule,
                id: row.id,
            }
        },
        // 更新确定
        determine() {
            this.$refs.applyForm.validate(async (valid) => {
                if (valid) {
                    this.DialogLoading = true
                    try {
                        let data = {
                            rules: this.applyForm.pointsRule,
                            id: this.applyForm.id,
                        }
                        
                        await api_postUpdateRuleInfo({ ...data })
                        this.DialogLoading = false
                        this.DialogShow = false
                        this.$baseMessage('操作成功', 'success')
                        this.getList()
                    } catch (error) {
                        this.DialogLoading = false
                    }
                } else {
                    return false
                }
            })
        },
    },
    computed: {},
};
</script>
<style lang="scss" scoped>
.acc-photo-index {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;

    .look-phone-btn {
        font-size: 10px;
        color: #1A5CF5;
        margin-left: 5px;
    }

    .fun-btn-box {
        margin-top: 20px;
    }

    .url {
        width: 120px;
        height: 56px;
        object-fit: fill;
        object-fit: contain;
        object-fit: cover;
        object-fit: none;
        object-fit: scale-down;
    }

    .status {
        width: 6px;
        height: 6px;
        display: inline-block;
        border-radius: 50%;
        vertical-align: middle;
    }

    .Passed {
        background: #05c8af;
    }

    .New {
        background: #1A5CF5;
    }

    .Reject {
        background: #F74A4A;
    }

    .button-div {
        overflow: hidden;
        float: right;
        margin-top: 33px;

        button {
            border: 0;
            width: 110px;
            height: 40px;
            border-radius: 2px;
            font-size: 16px;
        }

        .cancel {
            background: #F2F3F5;
            color: #666666;
        }
    }

    .ticketPicUrl {
        width: 150px;
        height: 150px;
        object-fit: fill;
        object-fit: contain;
        object-fit: cover;
        object-fit: none;
        object-fit: scale-down;
        cursor: pointer;
    }

    ::v-deep {
        .content {
            .title {
                margin-bottom: 20px;
            }

            .el-input {
                width: 100%;
            }
        }
    }
}</style>
  